<template lang="pug">
a.hatena-buttone(
  :href="shareIntent"
  target="_blank"
): img(src="../assets/images/hatebu.png" widgh=86 height=20)
</template>

<script>
import qs from "querystring";

export default {
  name: "hatena-button",
  props: {
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    shareIntent() {
      const search = qs.stringify({
        mode: "confirm",
        url: this.url
      });
      return `https://b.hatena.ne.jp/add?${search}`;
    }
  }
};
</script>
